module.exports = __webpack_public_path__ + "static/img/back.5b920ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/outer/back.png
// module id = 06H0
// module chunks = 226